// Mock data for Duru Halı Yıkama website

export const companyInfo = {
  name: "DURU",
  fullName: "Duru Halı Yıkama",
  tagline: "Hijyenin En Duru Hali",
  phones: ["0212 699 00 75", "0541 499 29 79"],
  email: "info@bahcesehirduruhaliyikama.com",
  address: "Bahçeşehir 2.kısım mahallesi şirinevler sokak no:7 Başakşehir/İstanbul",
  whatsapp: "905414992979",
  website: "www.bahcesehirduruhaliyikama.com",
  servicedAreas: ["Bahçeşehir", "Beylikdüzü", "Esenyurt", "Başakşehir", "Büyükçekmece (Alkent)"]
};

export const services = [
  {
    id: 1,
    title: "Halı Yıkama",
    description: "Profesyonel ekipmanlar ve çevre dostu deterjanlar ile halılarınız hijyenik bir şekilde yıkanır.",
    icon: "Waves",
    image: "https://images.unsplash.com/photo-1742483359033-13315b247c74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzY3MDYyMjJ8MA&ixlib=rb-4.1.0&q=85",
    features: ["Derin temizlik", "Hızlı kuruma", "Leke çıkarma", "Koku giderme"]
  },
  {
    id: 2,
    title: "Koltuk Yıkama",
    description: "Koltuk ve kanepeleriniz özel makinalarla evinizde yerinde temizlenir.",
    icon: "Armchair",
    image: "https://images.unsplash.com/photo-1686178827149-6d55c72d81df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxzb2ZhJTIwY2xlYW5pbmd8ZW58MHx8fHwxNzc2NzA2MjQ4fDA&ixlib=rb-4.1.0&q=85",
    features: ["Yerinde yıkama", "Kumaş koruma", "Antibakteriyel", "Hızlı servis"]
  },
  {
    id: 3,
    title: "Stor Perde",
    description: "Stor perdeleriniz profesyonel şekilde temizlenir ve bakımı yapılır.",
    icon: "Blinds",
    image: "https://images.pexels.com/photos/13005096/pexels-photo-13005096.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Söküm-takım", "Ütüleme", "Hijyenik yıkama", "Aynı gün teslimat"]
  },
  {
    id: 4,
    title: "Yorgan Yıkama",
    description: "Yorgan, battaniye ve yastıklarınız özel makinelerde hijyenik olarak yıkanır.",
    icon: "Bed",
    image: "https://images.pexels.com/photos/8774448/pexels-photo-8774448.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    features: ["Antibakteriyel yıkama", "Alerjen giderme", "Hava ile kuruma", "Paketleme"]
  }
];

export const carpetTypes = [
  {
    id: 1,
    name: "Makine Halısı",
    description: "Modern makine halıları profesyonel ekipmanlarla temizlenir.",
    image: "https://images.unsplash.com/photo-1707859379800-1e8ff273b648?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxtb2Rkcm4lMjBjYXJwZXR8ZW58MHx8fHwxNzc2MjU2MDQzfDA&ixlib=rb-4.1.0&q=85",
    care: "Dayanıklı yıkama ve hızlı kuruma avantajı."
  },
  {
    id: 2,
    name: "Shaggy Halı",
    description: "Uzun tüylü shaggy halılar özel bakım teknikleri ile yıkanır.",
    image: "https://images.pexels.com/photos/4107284/pexels-photo-4107284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    care: "Tüy yapısı korunarak derin temizlik yapılır."
  },
  {
    id: 3,
    name: "Bambu Halı",
    description: "Bambu halılar hassas yıkama ile temizlenir.",
    image: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxjYXJwZXQlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzYyNTYwMzl8MA&ixlib=rb-4.1.0&q=85",
    care: "Doğal yapısı korunarak özel deterjanlarla yıkanır."
  },
  {
    id: 4,
    name: "Viskon Halı",
    description: "İpeksi görünümlü viskon halılar özenle temizlenir.",
    image: "https://images.unsplash.com/photo-1654511830326-63a577771a7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHx1cGhvbHN0ZXJ5JTIwY2xlYW5pbmd8ZW58MHx8fHwxNzc2MjU2MDc5fDA&ixlib=rb-4.1.0&q=85",
    care: "Parlak görünümü koruyacak şekilde yıkanır."
  },
  {
    id: 5,
    name: "Akrilik Halı",
    description: "Dayanıklı akrilik halılar ekonomik fiyatlarla yıkanır.",
    image: "https://images.unsplash.com/photo-1664623770970-a49e994b096b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHx1cGhvbHN0ZXJ5JTIwY2xlYW5pbmd8ZW58MHx8fHwxNzc2MjU2MDc5fDA&ixlib=rb-4.1.0&q=85",
    care: "Leke direnci yüksek, kolay temizlenir."
  },
  {
    id: 6,
    name: "Kilim",
    description: "El dokuması kilimler geleneksel yöntemlerle temizlenir.",
    image: "https://images.unsplash.com/photo-1694721025063-08eff99ba558?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxzb2ZhJTIwY2xlYW5pbmd8ZW58MHx8fHwxNzc2MjU2MDc1fDA&ixlib=rb-4.1.0&q=85",
    care: "Renk sabitliği ve desen koruması garantili."
  },
  {
    id: 7,
    name: "El Dokuma",
    description: "Değerli el dokuma halılar uzman ellerle yıkanır.",
    image: "https://images.unsplash.com/photo-1745127262997-214698891f3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxjYXJwZXQlMjB3YXNoaW5nfGVufDB8fHx8MTc3NjcwNjIxN3ww&ixlib=rb-4.1.0&q=85",
    care: "Özel koruma ve hassas yıkama teknikleri uygulanır."
  },
  {
    id: 8,
    name: "Yün Halı",
    description: "Geleneksel yün halılar özel bakım ile temizlenir.",
    image: "https://images.pexels.com/photos/26756401/pexels-photo-26756401.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    care: "Doğal yün için özel deterjan kullanılır."
  },
  {
    id: 9,
    name: "Isparta Halısı",
    description: "Geleneksel Isparta halıları özenle yıkanır.",
    image: "https://images.pexels.com/photos/14675105/pexels-photo-14675105.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    care: "Renk ve desen koruması önceliklidir."
  },
  {
    id: 10,
    name: "Hasır Halı",
    description: "Doğal hasır halılar özel yöntemlerle temizlenir.",
    image: "https://images.unsplash.com/photo-1707859379800-1e8ff273b648?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjYXJwZXR8ZW58MHx8fHwxNzc2MjU2MDQzfDA&ixlib=rb-4.1.0&q=85",
    care: "Doğal yapısı korunarak temizlenir."
  },
  {
    id: 11,
    name: "Hereke Halısı",
    description: "Değerli Hereke halıları uzman ellerde.",
    image: "https://images.pexels.com/photos/4107284/pexels-photo-4107284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    care: "En yüksek kalite standartlarıyla yıkanır."
  },
  {
    id: 12,
    name: "Ladik Halısı",
    description: "Geleneksel Ladik halıları profesyonelce yıkanır.",
    image: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxjYXJwZXQlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzYyNTYwMzl8MA&ixlib=rb-4.1.0&q=85",
    care: "Renk ve motif koruması garantili."
  },
  {
    id: 13,
    name: "Step Halı",
    description: "Modern step halılar hızlı ve etkili temizlenir.",
    image: "https://images.unsplash.com/photo-1654511830326-63a577771a7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHx1cGhvbHN0ZXJ5JTIwY2xlYW5pbmd8ZW58MHx8fHwxNzc2MjU2MDc5fDA&ixlib=rb-4.1.0&q=85",
    care: "Pratik ve ekonomik yıkama çözümü."
  },
  {
    id: 14,
    name: "Uşak Halısı",
    description: "Tarihi Uşak halıları özel koruma ile yıkanır.",
    image: "https://images.unsplash.com/photo-1664623770970-a49e994b096b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHx1cGhvbHN0ZXJ5JTIwY2xlYW5pbmd8ZW58MHx8fHwxNzc2MjU2MDc5fDA&ixlib=rb-4.1.0&q=85",
    care: "Antika değeri korunarak temizlenir."
  },
  {
    id: 15,
    name: "Çin Halısı",
    description: "Değerli Çin halıları uzman bakım ile yıkanır.",
    image: "https://images.unsplash.com/photo-1694721025063-08eff99ba558?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxzb2ZhJTIwY2xlYW5pbmd8ZW58MHx8fHwxNzc2MjU2MDc1fDA&ixlib=rb-4.1.0&q=85",
    care: "İnce işçilik korunarak temizlenir."
  },
  {
    id: 16,
    name: "Afgan Halısı",
    description: "Geleneksel Afgan halıları profesyonelce yıkanır.",
    image: "https://images.unsplash.com/photo-1745127262997-214698891f3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxjYXJwZXQlMjB3YXNoaW5nfGVufDB8fHx8MTc3NjcwNjIxN3ww&ixlib=rb-4.1.0&q=85",
    care: "Kalın dokuma yapısına uygun yıkama."
  },
  {
    id: 17,
    name: "Bünyan Halı",
    description: "Bünyan halıları özel tekniklerle temizlenir.",
    image: "https://images.pexels.com/photos/9788329/pexels-photo-9788329.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    care: "Geleneksel dokuya uygun bakım."
  },
  {
    id: 18,
    name: "İran Halısı",
    description: "Değerli İran halıları özenle yıkanır.",
    image: "https://images.pexels.com/photos/14675105/pexels-photo-14675105.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    care: "En üst düzey koruma ve temizlik."
  },
  {
    id: 19,
    name: "İpek Halı",
    description: "Lüks ipek halılar hassas yıkama ile temizlenir.",
    image: "https://images.pexels.com/photos/4107284/pexels-photo-4107284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    care: "Soğuk su ve özel ipek deterjanı kullanılır."
  },
  {
    id: 20,
    name: "Nepal Halısı",
    description: "El yapımı Nepal halıları profesyonelce yıkanır.",
    image: "https://images.unsplash.com/photo-1707859379800-1e8ff273b648?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjYXJwZXR8ZW58MHx8fHwxNzc2MjU2MDQzfDA&ixlib=rb-4.1.0&q=85",
    care: "El dokuması özelliği korunur."
  },
  {
    id: 21,
    name: "Deri Halı",
    description: "Deri halılar özel bakım ürünleri ile temizlenir.",
    image: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxjYXJwZXQlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzYyNTYwMzl8MA&ixlib=rb-4.1.0&q=85",
    care: "Deri yumuşatıcı ve koruyucu uygulanır."
  },
  {
    id: 22,
    name: "Patchwork",
    description: "Modern patchwork halılar özenle yıkanır.",
    image: "https://images.unsplash.com/photo-1654511830326-63a577771a7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHx1cGhvbHN0ZXJ5JTIwY2xlYW5pbmd8ZW58MHx8fHwxNzc2MjU2MDc5fDA&ixlib=rb-4.1.0&q=85",
    care: "Renk karışması olmadan güvenli yıkama."
  }
];

export const blogPosts = [
  {
    id: 1,
    slug: "hali-bakim-ipuclari",
    title: "Halı Bakım İpuçları: Halınızı Nasıl Uzun Ömürlü Yaparsınız?",
    excerpt: "Halılarınızın ömrünü uzatmak için düzenli bakım şarttır. İşte profesyonel halı bakım ipuçları...",
    category: "Bakım İpuçları",
    region: "Genel",
    date: "2024-01-15",
    image: "https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxjYXJwZXQlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzYyNTYwMzl8MA&ixlib=rb-4.1.0&q=85",
    content: "Halılarınızın ömrünü uzatmak ve görünümünü korumak için düzenli bakım çok önemlidir. Haftada en az bir kez elektrikli süpürge ile temizlik yapılmalıdır..."
  },
  {
    id: 2,
    slug: "bahcesehir-hali-yikama",
    title: "Bahçeşehir'de Halı Yıkama: En İyi Hizmet",
    excerpt: "Bahçeşehir bölgesinde profesyonel halı yıkama hizmeti almak için bilmeniz gerekenler...",
    category: "Bölge Rehberi",
    region: "Bahçeşehir",
    date: "2024-01-12",
    image: "https://images.unsplash.com/photo-1742483359033-13315b247c74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxjYXJwZXQlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzYyNTYwMzl8MA&ixlib=rb-4.1.0&q=85",
    content: "Bahçeşehir'de yaşıyorsanız ve kaliteli halı yıkama hizmeti arıyorsanız, ücretsiz alım-teslim hizmetimizden faydalanabilirsiniz..."
  },
  {
    id: 3,
    slug: "beylikduzu-hali-yikama",
    title: "Beylikdüzü Halı Yıkama: Hızlı ve Güvenilir",
    excerpt: "Beylikdüzü'nde halı yıkama için en uygun çözümler ve ücretsiz servis hizmeti...",
    category: "Bölge Rehberi",
    region: "Beylikdüzü",
    date: "2024-01-11",
    image: "https://images.pexels.com/photos/4107284/pexels-photo-4107284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    content: "Beylikdüzü'nde halı yıkama hizmeti arayanlar için ücretsiz alım-teslim ile kapınızdayız. 2-3 gün içinde tertemiz halılarınıza kavuşun..."
  },
  {
    id: 4,
    slug: "esenyurt-hali-yikama",
    title: "Esenyurt'ta Profesyonel Halı Yıkama",
    excerpt: "Esenyurt bölgesinde kaliteli ve ekonomik halı yıkama hizmeti...",
    category: "Bölge Rehberi",
    region: "Esenyurt",
    date: "2024-01-10",
    image: "https://images.unsplash.com/photo-1707859379800-1e8ff273b648?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjYXJwZXR8ZW58MHx8fHwxNzc2MjU2MDQzfDA&ixlib=rb-4.1.0&q=85",
    content: "Esenyurt'ta yaşayan müşterilerimize özel halı yıkama kampanyaları ve ücretsiz servis hizmeti sunuyoruz..."
  },
  {
    id: 5,
    slug: "basaksehir-hali-yikama",
    title: "Başakşehir Halı Yıkama Hizmetleri",
    excerpt: "Başakşehir'de halı ve koltuk yıkama için güvenilir adres...",
    category: "Bölge Rehberi",
    region: "Başakşehir",
    date: "2024-01-09",
    image: "https://images.unsplash.com/photo-1686178827149-6d55c72d81df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxzb2ZhJTIwY2xlYW5pbmd8ZW58MHx8fHwxNzc2MjU2MDc1fDA&ixlib=rb-4.1.0&q=85",
    content: "Başakşehir merkezimizden tüm bölgeye hizmet veriyoruz. Halı, koltuk, stor perde ve yorgan yıkama hizmetlerimizden yararlanın..."
  },
  {
    id: 6,
    slug: "buyukcekmece-alkent-hali-yikama",
    title: "Büyükçekmece (Alkent) Halı Yıkama",
    excerpt: "Büyükçekmece Alkent bölgesinde profesyonel halı yıkama hizmeti...",
    category: "Bölge Rehberi",
    region: "Büyükçekmece",
    date: "2024-01-08",
    image: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxjYXJwZXQlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzYyNTYwMzl8MA&ixlib=rb-4.1.0&q=85",
    content: "Büyükçekmece Alkent bölgesine özel halı yıkama hizmetimiz ile ücretsiz alım-teslim avantajından yararlanın..."
  },
  {
    id: 7,
    slug: "leke-cikarma-yontemleri",
    title: "Leke Çıkarma Yöntemleri: Evde Uygulanabilir Pratik Çözümler",
    excerpt: "Halınıza dökülen kahve, çay veya diğer lekeleri çıkarmak için pratik ve etkili yöntemler...",
    category: "Leke Çıkarma",
    region: "Genel",
    date: "2024-01-07",
    image: "https://images.pexels.com/photos/5233264/pexels-photo-5233264.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    content: "Halınıza leke bulaştığında panik yapmayın! İlk müdahale çok önemlidir. Lekeyi ovmadan temiz bir bezle bastırarak fazla sıvıyı alın..."
  },
  {
    id: 8,
    slug: "koltuk-temizligi-siklik",
    title: "Koltuk Temizliği: Ne Sıklıkla Yaptırmalısınız?",
    excerpt: "Koltuk ve kanepelerinizin hijyenik kalması için önerilen temizlik sıklığı ve yöntemleri...",
    category: "Bakım İpuçları",
    region: "Genel",
    date: "2023-12-20",
    image: "https://images.pexels.com/photos/14675105/pexels-photo-14675105.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    content: "Koltuklar evimizin en çok kullanılan mobilyalarındandır. Günlük kullanım nedeniyle koltuklar kir, toz, bakteri ve alerjen biriktirir..."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ayşe Yılmaz",
    location: "Beylikdüzü, İstanbul",
    rating: 5,
    comment: "Antika halımı emanet etmekten çekiniyordum ama sonuç harikaydı! Çok teşekkür ederim.",
    date: "2024-01-10"
  },
  {
    id: 2,
    name: "Mehmet Demir",
    location: "Bahçeşehir, İstanbul",
    rating: 5,
    comment: "Koltuk takımımız yeni gibi oldu. Hızlı ve kaliteli hizmet için teşekkürler.",
    date: "2024-01-08"
  },
  {
    id: 3,
    name: "Zeynep Kaya",
    location: "Esenyurt, İstanbul",
    rating: 5,
    comment: "Her yıl halılarımızı yıkatıyoruz. Güvenilir ve profesyonel ekip.",
    date: "2024-01-05"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Profesyonel Ekip",
    description: "Uzman ve deneyimli ekibimiz ile kaliteli hizmet",
    icon: "Users"
  },
  {
    id: 2,
    title: "Modern Ekipman",
    description: "Son teknoloji yıkama ve kurutma makineleri",
    icon: "Settings"
  },
  {
    id: 3,
    title: "Çevre Dostu",
    description: "Organik ve çevre dostu temizlik ürünleri",
    icon: "Leaf"
  },
  {
    id: 4,
    title: "Ücretsiz Servis",
    description: "Alım ve teslim hizmeti ücretsiz",
    icon: "Truck"
  },
  {
    id: 5,
    title: "Hızlı Teslimat",
    description: "2-3 gün içinde teslim garantisi",
    icon: "Clock"
  },
  {
    id: 6,
    title: "Uygun Fiyat",
    description: "Kaliteden ödün vermeden uygun fiyatlar",
    icon: "BadgePercent"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Halı yıkama kaç gün sürer?",
    answer: "Standart halı yıkama işlemi 2-3 gün içinde tamamlanır. Hava koşullarına göre süre değişebilir."
  },
  {
    id: 2,
    question: "Alım ve teslim ücreti var mı?",
    answer: "Hayır, Bahçeşehir, Beylikdüzü, Esenyurt, Başakşehir ve Büyükçekmece (Alkent) bölgelerinde alım ve teslim hizmetimiz tamamen ücretsizdir."
  },
  {
    id: 3,
    question: "Antika halıları yıkıyor musunuz?",
    answer: "Evet, antika ve değerli halılarınız (Hereke, İran, İpek vb.) için özel bakım ve yıkama hizmeti sunuyoruz."
  },
  {
    id: 4,
    question: "Leke çıkarma garantisi var mı?",
    answer: "Çoğu leke için %90 başarı oranımız vardır. Ancak bazı eski ve kalıcı lekeler tamamen çıkmayabilir."
  },
  {
    id: 5,
    question: "Koltuk yıkama evde mi yapılır?",
    answer: "Evet, koltuk yıkama hizmeti sadece evinizde yerinde yapılır. Profesyonel ekipmanlarımızla evinize gelir ve koltuk takımınızı yerinde temizleriz."
  },
  {
    id: 6,
    question: "Hangi bölgelere hizmet veriyorsunuz?",
    answer: "Bahçeşehir, Beylikdüzü, Esenyurt, Başakşehir ve Büyükçekmece (Alkent) bölgelerine ücretsiz alım-teslim hizmeti sunuyoruz."
  }
];
